import { IconBrandChrome, IconBeach, IconUser, IconUsers, IconTournament, IconUserPlus, IconCalendarStats, IconAffiliate, IconAbacus, IconCalendarEvent, IconCalendarOff, IconCalendar, IconUserSearch, IconTriangleSquareCircle, IconMathSymbols    } from '@tabler/icons';
import {GroupsIcon }from 'assets/images/icons/groups'
// constant
const icons = { IconCalendar, IconCalendarOff, IconCalendarEvent, IconAbacus, IconBrandChrome, IconBeach, IconUser, IconUsers, IconTournament, IconUserPlus, IconCalendarStats, IconAffiliate, IconUserSearch, IconTriangleSquareCircle, IconMathSymbols };

// ==============================|| MENU Adminstracion ||============================== //

const TournamentOperationsMenu = {
    id: 'Operations',
    title: 'Operaciones',
    type: 'group',
    children: [
      {
        id: 'Torneos',
        title: 'Torneos',
        type: 'collapse',
        icon: icons.IconUsers,
        children: [
            {
                id: 'CalculaTorneo',
                title: 'Calculadora de Torneos',
                type: 'item',
                url: 'views/tournamentcalculatorform',
                icon: icons.IconMathSymbols,
                breadcrums: true,
            },            
            {
                id: 'ConfiguraTorneo',
                title: 'Administrar Torneos',
                type: 'item',
                url: 'views/tournament/createevent',
                icon: icons.IconUsers,
                breadcrums: true
            },
            {
                id: 'AddMoreTimeSlots',
                title: 'Agregar horarios',
                type: 'item',
                url: 'views/tournament/addmoretimeslots',
                icon: icons.IconCalendarEvent,
                breadcrums: true
            },
            
        ]},

        {
            id: 'teams',
            title: 'Parejas',
            type: 'collapse',
            icon: icons.IconUsers,
            breadcrums: true,
            children: [
                {
                    id: 'CargarEquipos',
                    title: 'Cargar',
                    type: 'item',
                    url: 'views/uploadteamscsv',
                    icon: icons.IconUsers,
                    breadcrums: true
                },                    
                {
                    id: 'EditarEquipos',
                    title: 'Editar',
                    type: 'item',
                    url: 'views/teamslist',
                    icon: icons.IconUsers,
                    breadcrums: true
                },     {
                    id: 'TournamentPayments',
                    title: 'Pagos',
                    type: 'item',
                    url: 'views/listpayments',
                    icon: icons.IconUsers,
                    breadcrums: true
                },                    
            ]
        },
        {
            id: 'GroupAdmin1',
            title: 'Grupos',
            type: 'collapse',
            icon: GroupsIcon,
            children: [
                {
                    id: 'Crear Grupos',
                    title: 'Crear Grupos',
                    type: 'item',
                    url: 'views/tournament/creategroups',
                    icon: GroupsIcon,
                    breadcrums: true
                },
                {
                    id: 'DisplayGroups',
                    title: 'Editar Grupos',
                    type: 'item',
                    url: 'views/groups/draw',
                    icon: GroupsIcon,
                    breadcrums: true

                },
                {
                    id: 'CreateGames',
                    title: 'Crear Partidos',
                    type: 'item',
                    url: 'views/groups/creategames',
                    icon: GroupsIcon,
                    breadcrums: true

                },
                {
                    id: 'AssignRoundsToGames',
                    title: 'Asignar Rondas a Partidos',
                    type: 'item',
                    url: 'views/assignroundstogames',
                    icon: GroupsIcon,
                    breadcrums: true    
                }, 
            ]
        },
        {
            id: 'CalendarsAdmin1',
            title: 'Calendario',
            type: 'collapse',
            icon: icons.IconCalendarStats,
            children: [
                {
                    id: 'Calendario',
                    title: 'Calendario Juegos',
                    type: 'item',
                    url: 'views/gameplanning',
                    icon: icons.IconCalendarEvent,
                    breadcrums: true

                },
                {
                    id: 'ShowCalendario',
                    disabled: false,
                    title: 'Proyectar Calendario',
                    type: 'item',
                    url: 'views/drawGameLandarFullScreen',
                    icon: icons.IconCalendarEvent,
                    breadcrums: false

                },
                {
                    id: 'DailyGames',
                    title: 'Partidos diarios',
                    type: 'item',
                    url: 'views/gameplanning/drawgamecalendar',
                    icon: icons.IconCalendarEvent,
                    breadcrums: true

                },
                {
                    id: 'GamesByDate',
                    title: 'Rol  de juegos',
                    type: 'item',
                    url: 'views/gameplanning/gamesrol',
                    icon: icons.IconCalendarEvent,
                    breadcrums: true

                },
                {
                    id: 'GamesByRound',
                    title: 'Rol por rondas',
                    type: 'item',
                    url: 'views/gameplanning/gamesrolbyrounds',
                    icon: icons.IconCalendarEvent,
                    breadcrums: true
                },
                {
                    id: 'WhenDoIPlay',
                    title: 'Cuando son mis partidos',
                    type: 'item',
                    url: 'views/gameplanning/whendoiplay',
                    icon: icons.IconCalendarEvent,
                    breadcrums: true

                },
 
            ]
        },
        {
            id: 'ResultsAdmin1',
            title: 'Resultados',
            type: 'collapse',
            icon: icons.IconTournament,
            children: [
                {
                    id: 'GroupResults',
                    title: 'Resultados por Grupo',
                    type: 'item',
                    url: 'views/roundrobinwinner',
                    icon: icons.IconTournament,
                    breadcrums: true

                },
                {
                    id: 'Playoffs',
                    title: 'Eliminatorias',
                    type: 'item',
                    url: 'views/playoffs/DrawBrackets',
                    icon: icons.IconTournament,
                    breadcrums: true

                },
                {
                    id: 'AddRankingPoints',
                    title: 'Actualizar puntos',
                    type: 'item',
                    url: 'views/pointsawarded',
                    icon: icons.IconTournament,
                    breadcrums: true

                },
            
            ]
        }, 
         {
            id: 'AdminSection',
            title: 'Administracion',
            type: 'collapse',
            icon: icons.IconUser,
            children: [
                {
                    id: 'Players',
                    title: 'Jugadores',
                    type: 'item',
                    url: 'views/institutionalplayers',
                    icon: icons.IconUser,
                    breadcrums: true
                },                    
                {
                    id: 'printableSetup',
                    title: 'Imagenes',
                    type: 'item',
                    url: 'views/images',
                    icon: icons.IconCalendarEvent,
                    breadcrums: true

                },
                {
                    id: 'ListadoPartidos',
                    title: 'Listado de partidos',
                    type: 'item',
                    url: 'views/reports',
                    icon: icons.IconCalendarEvent,
                    breadcrums: true

                },
                {
                    id: 'CalculaPlayoffs',
                    title: 'Calcula playoffs',
                    type: 'item',
                    url: 'views/calculateplayoffs',
                    icon: icons.IconCalendarEvent,
                    breadcrums: true

                },
                {
                    id: 'Categories',
                    title: 'Categorias',
                    type: 'item',
                    url: 'views/categories',
                    icon: icons.IconTriangleSquareCircle,
                    breadcrums: true

                },
                
            ]
        },

    ]
};



export { TournamentOperationsMenu };
